<div *ngIf="!showAsDrawer" class="sub-header px-3">
  <!-- <app-breadcrumb [breadcrumbs]="breadcrumbs"></app-breadcrumb> -->
</div>
<div *ngIf="!showAsDrawer" class="search-container py-3 align-items-center d-flex row px-3 mb-1 pb-4">
  <h4 class="col-md-5 mb-0">Master Catalog</h4>
  <div class="col-md-7 px-4 search-input-block d-flex align-items-center justify-content-end">
    @if(viewEditForm == 'Edit' || viewEditForm == 'View'){
    <ng-container>
      <button nz-button nzType="primary" class="d-flex align-items-center" [nzSize]="'default'" (click)="loadAddForm()"
        [disabled]="!authService.MCAdd">
        Add Product
      </button>
    </ng-container>
    }
  </div>
</div>
<div class="row" *ngIf="isLoading"><app-spinner></app-spinner></div>
<div class="row p-0 mt-3 catalog-container justify-content-center  d-flex align-items-center" *ngIf="!isLoading">
  <div class="row">
    <div class="d-flex w-100 h-100 justify-content-evenly px-0">
      <app-add-product-details *ngIf="!showAsDrawer" style="width: 35%;" [catalogAddForm]="catalogAddForm"
        [resetListDetails]="resetListDetails" (emitResetAction)="reset()" [newMC]="saveMc"
        (emitSelectedProduct)="loadMasterCatalogProduct($event)" [applyStyleAction]="false"></app-add-product-details>
      <div class="catalog-form-container w-60 p-2 ml-10" *ngIf="isProductLoading"><app-spinner></app-spinner></div>
      <div class="catalog-form-container w-60 p-2 ml-10" *ngIf="!isProductLoading"
        [ngClass]="showAsDrawer ? 'width-100' : '' ">
        @if(!viewEditForm){
        <ng-container>
          <div class="wrapper d-flex flex-column">
            <div class="new-catalog-wrapper d-flex flex-column justify-content-center align-items-center">
              <div class="image-wrapper">
                <img src="Illustration.png" />
              </div>
              <h5 class="mb-2 fs-16">Start Adding Product to the Master Catalog!</h5>
              <span class="mb-3 fs-12">Or select a product from the left panel to View/edit it.</span>
              <button nz-button nzType="primary" (click)="loadAddForm()" [disabled]="!authService.MCAdd">Add
                Product</button>
            </div>
          </div>
        </ng-container>
        }
        @else if(viewEditForm == 'Add' || viewEditForm == 'Edit' || viewEditForm == 'View') {
        <ng-container>
          <div class="wrapper position-relative">
            <div class="sticky-header header d-flex row align-items-center">
              <div class="col-md-3">
                <h5 class="px-4 py-3">{{getTitle()}}</h5>
              </div>
              <div class="col-md-9 d-flex justify-content-end">
                <ng-container>
                  <button *ngIf="!showAsDrawer" nz-button nzType="default" class="d-flex align-items-center mr-10"
                    [nzSize]="'default'"
                    (click)="viewEditForm = '';addEditCatalogForm.reset();addEditCatalogForm.enable()">
                    Cancel
                  </button>
                  @if((!salsifyProduct || copyProduct) && !deletedProduct && isAccessExists()){
                  <button nz-button nzType="default" class="d-flex align-items-center mr-10" [nzSize]="'default'"
                    (click)="showModal=true">
                    Reset
                  </button>
                  }
                  <button [disabled]="(salsifyProduct && !copyProduct) || deletedProduct || !isAccessExists()"
                    (click)="addProduct(addEditCatalogForm)" nz-button nzType="primary"
                    class="d-flex align-items-center mr-10" [nzSize]="'default'">
                    Save
                  </button>
                  @if(viewEditForm != 'Add' && !deletedProduct){

                  <button [disabled]="selectedProdctDetails.totalLinkedProducts == 0" (click)="productList = true"
                    nz-button nzType="primary" class="mr-10 d-flex align-items-center justify-content-center "
                    [nzSize]="'default'">
                    Linked Products
                  </button>
                  <span class="badge badge-circle mt-0">{{selectedProdctDetails?.totalLinkedProducts}}</span>

                  }
                </ng-container>
              </div>
            </div>
            <form [formGroup]="addEditCatalogForm">
              <div class="add-catalog-form p-4 row">
                @for(input of masterCatalogFields; track input.label){
                @if(input.type == 'input'){
                <div class="col-md-6 mb-2" [ngClass]="input.label == 'Display Name' ? 'col-md-12' : '' ">
                  <label class="form-label">{{input.label}}
                    @if(getCtrlValue(input?.formControlName)?.errors?.required){
                    <span class="text-danger">*</span>
                    }</label>
                  @if(input.autocomplete){
                  <input (input)="convertToUppercase(input.formControlName)" nz-input type="text" class="form-control"
                    [formControlName]="input.formControlName" placeholder={{input?.placeholder}} [nzAutocomplete]="auto"
                    (blur)="validateSelection(input.formControlName)">
                  <nz-autocomplete #auto (nzOnSelect)="selectedOption($event,input.label)">
                    @if(input.label == 'Style ID'){
                    @for (option of filteredStyleIdList; track $index) {
                    <nz-auto-option [nzValue]="option?.styleId">{{ option?.styleId | uppercase}}</nz-auto-option>
                    }
                    }
                    @else if(input.label == 'Brand'){
                    @for (option of filteredBrandList; track $index) {
                    <nz-auto-option [nzValue]="option">{{ option }}</nz-auto-option>
                    }
                    }
                    @else if(input.label == 'Garment'){
                    @for (option of filteredGarmentList; track $index) {
                    <nz-auto-option [nzValue]="option">{{ option }}</nz-auto-option>
                    }
                    }
                    @else if(input.label == 'Sub-garment'){
                    @for (option of filteredSubGarmentList; track $index) {
                    <nz-auto-option [nzValue]="option">{{ option }}</nz-auto-option>
                    }
                    }

                  </nz-autocomplete>
                  }
                  @else {
                  @if(input.formControlName === 'newVersion'){
                  <input (keydown)="validateVersionInput($event, 'keydown')"
                    (paste)="validateVersionInput($event, 'paste')" (blur)="trimVersion()"
                    [title]="input.label == 'Display Name' ? getCtrlValue(input?.formControlName)?.value : ''"
                    type="text" class="form-control" formControlName="{{input?.formControlName}}"
                    placeholder={{input?.placeholder}} [value]="input.value" [attr.maxlength]="input.maxLength ?? null">
                  }
                  @else{
                  <input [title]="input.label == 'Display Name' ? getCtrlValue(input?.formControlName)?.value : ''"
                    type="text" class="form-control" formControlName="{{input?.formControlName}}"
                    placeholder={{input?.placeholder}} [value]="input.value" [attr.maxlength]="input.maxLength ?? null">
                  }
                  }
                  <span class="text-danger" *ngIf="(getCtrlValue(input?.formControlName)?.errors?.required && !getCtrlValue(input?.formControlName)?.value && (getCtrlValue(input?.formControlName)?.touched) ) ||
                  ( (inValidProductForm && getCtrlValue(input?.formControlName)?.errors?.required)
                && !getCtrlValue(input?.formControlName)?.value) ">
                    {{input.label}} is required.
                  </span>
                </div>
                }
                @else if(input.type == 'dropdown'){
                <div class="col-md-6 mb-2 d-flex flex-column">
                  <label class="form-label">{{input.label}}
                    @if(getCtrlValue(input?.formControlName)?.errors?.required){
                    <span class="text-danger">*</span>
                    }
                  </label>
                  @if(input.label == 'Gender' ){
                  <nz-select nzPlaceHolder="Select" nzSize="default" formControlName="{{input?.formControlName}}"
                    style="height: 38px !important;">
                    <nz-option nzLabel="Unisex" nzValue=0></nz-option>
                    <nz-option nzLabel="Male" nzValue=1></nz-option>
                    <nz-option nzLabel="Female" nzValue=2></nz-option>
                  </nz-select>
                  }
                  @if(input.label == 'CAT Level' ){
                  <nz-select nzPlaceHolder="Select" nzSize="default" formControlName="{{input?.formControlName}}"
                    style="height: 38px !important;">
                    <nz-option nzLabel="Select" nzValue=0></nz-option>
                    <nz-option nzLabel="CAT Level 1" nzValue=1></nz-option>
                    <nz-option nzLabel="CAT Level 2" nzValue=2></nz-option>
                    <nz-option nzLabel="CAT Level 3" nzValue=3></nz-option>
                    <nz-option nzLabel="CAT Level 4" nzValue=4></nz-option>
                  </nz-select>
                  }
                  @else if(input.label == 'Style ID' ){
                  @if(viewEditForm == 'Add'){
                  <nz-select nzPlaceHolder="Select" nzSize="default" formControlName="{{input?.formControlName}}"
                    style="height: 38px !important;">
                    @for(style of styleIdList; track style.styleId){
                    <nz-option [nzLabel]="style.styleId" [nzValue]="style.styleId"></nz-option>
                    }
                  </nz-select>
                  }
                  @else {
                  <input type="text" class="form-control" formControlName="{{input?.formControlName}}"
                    placeholder={{input?.placeholder}} [value]="input.value">
                  }
                  }
                  <span class="text-danger" *ngIf="(getCtrlValue(input?.formControlName)?.errors?.required && !getCtrlValue(input?.formControlName)?.value && (getCtrlValue(input?.formControlName)?.touched)) ||
                  ( (inValidProductForm && getCtrlValue(input?.formControlName)?.errors?.required)
                && !getCtrlValue(input?.formControlName)?.value) ">
                    {{input.label}} is required.
                  </span>
                </div>

                }
                @else if(input.type == 'textarea'){
                <div class="col-md-12 mb-2">
                  <label class="form-label">{{input.label}}</label>
                  <div class="input-group">
                    <textarea type="text" [attr.maxlength]="input.maxLength ?? null"
                      formControlName="{{input?.formControlName}}" [rows]="input?.rows" class="form-control"
                      placeholder={{input?.placeholder}} [value]="input.value"></textarea>
                  </div>
                  <span class="text-danger" *ngIf="(getCtrlValue(input?.formControlName)?.errors?.required && !getCtrlValue(input?.formControlName)?.value && (getCtrlValue(input?.formControlName)?.touched)) ||
                  ((inValidProductForm && getCtrlValue(input?.formControlName)?.errors?.required)
                && !getCtrlValue(input?.formControlName)?.value) ">
                    {{input.label}} is required.
                  </span>
                </div>
                }
                @else if(input.type == 'checkbox'){
                <div class="col-md-3 mt-1 d-flex align-items-center">
                  <div class="form-check">
                    <input class="form-check-input" formControlName="{{input?.formControlName}}" type="checkbox">
                    <label class="form-check-label">{{input.label}}</label>
                  </div>
                </div>
                }
                }
              </div>

              <div class="header d-flex row align-items-center mb-2">
                <div class="col-md-9 px-4">
                  Product Details
                </div>
                <div class="col-md-3 mb-2 d-flex">
                  <ng-container>
                    <button style="width: 100%;"
                      [disabled]="(salsifyProduct && !copyProduct) || deletedProduct || !isAccessExists()" nz-button
                      nzType="primary" (click)="attirbutePanel = true"
                      class="d-flex justify-content-center align-items-center" [nzSize]="'default'">
                      {{attrArrayControls.length == 0 ? 'Add Product Details' : 'Edit Product Details'
                      }}
                    </button>
                  </ng-container>
                </div>
              </div>
              <div class="add-catalog-form p-4 row">
                <ng-container *ngIf="attrArrayControls.length > 0 && attrValArray.value.length > 0  ">
                  <ng-container formArrayName="attributeArray">
                    <div class="col-md-12 attribute-block" *ngFor="let descForm of attrArrayControls; let i = index"
                      [formGroupName]="i">
                      <nz-collapse class="search-panel product-feature-section mt-2 mb-2">
                        <nz-collapse-panel #panelRef [nzExtra]="customExpandIcon" [nzShowArrow]="false"
                          [nzActive]="descForm.controls['collapse'].value" [nzHeader]="header"
                          (nzActiveChange)="handleCollapse(i)">

                          <div class="d-flex align-items-center">
                            <ng-template #customExpandIcon>
                              <div class="extra-icon-block">
                                <img class="expand-icon"
                                  [src]="descForm.controls['collapse'].value ? 'arrow_up.png' : 'arrow_down.png'"
                                  (click)="handleCollapse(i)">
                              </div>
                            </ng-template>
                            <ng-template #header>
                              <h5 class="d-flex mt-2"> {{descForm.get('attributeName')?.value}} </h5>
                            </ng-template>
                          </div>
                          <div class="d-flex flex-wrap mt-2">
                            <div></div>
                            <div
                              [ngClass]="descForm.get('attributeName')?.value == 'Bullets' ? 'd-flex flex-column' : ''">
                              @for(tag of descForm.controls['attrValArray'].value; let j = $index; track tag){
                              <ng-container>
                                <nz-tag [innerHTML]="tag?.attributeValue" class="m-1 text-wrap"></nz-tag>
                              </ng-container>
                              }
                            </div>
                          </div>
                        </nz-collapse-panel>
                      </nz-collapse>
                    </div>
                  </ng-container>
                </ng-container>
                <div class="text-center" *ngIf="attrArrayControls.length == 0 || attrValArray.value.length == 0">
                  <span class="mb-3 fs-12">No product details added yet!</span>
                </div>
              </div>
              <div class="header d-flex row align-items-center mb-2">
                <div class="col-md-9 px-4">
                  Keywords for Product Search
                </div>
              </div>
              <div class="add-catalog-form p-4 row">
                <ng-container>
                  <div *ngIf="(!salsifyProduct || copyProduct) && !deletedProduct && isAccessExists()"
                    class="mb-1 px-1 col-md-7 position-relative">
                    <label class="form-label">
                    </label>
                    <input (keydown.enter)="$event.preventDefault();$event.stopPropagation();addKeyWord()" type="text"
                      class="form-control" placeholder="Enter Keyword" formControlName="keyWord">
                  </div>
                  <div *ngIf="(!salsifyProduct || copyProduct) && !deletedProduct && isAccessExists()"
                    class="col-md-1 mt-0 px-1">
                    <label class="form-label">
                    </label>
                    <button (click)="addKeyWord()" class="d-flex px-4 align-items-center justify-content-center"
                      nz-button nzType="default">
                      Add
                    </button>
                  </div>
                  @if(keyWordsArray.value.length > 0){
                  <div class="lot-keyword-section mt-2 mb-2 p-3">
                    @if((!salsifyProduct || copyProduct ) && !deletedProduct && isAccessExists()){
                    <div class="d-flex flex-wrap mt-2 w-100" cdkDropList [cdkDropListData]="keyWordsArray.controls"
                      cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event,keyWordsArray.controls)">

                      @for(tag of keyWordsArray.controls; let j = $index; track tag) {

                      <nz-tag style="cursor: move;" cdkDrag class="text-wrap mb-2" (nzOnClose)="removeKeyWord(j)"
                        nzMode="closeable">{{tag?.value}}</nz-tag>
                      }
                    </div>
                    }
                    @if( (salsifyProduct && !copyProduct) || deletedProduct || !isAccessExists()){
                    <div class="d-flex flex-wrap mt-2">

                      @for(tag of keyWordsArray.value; let j = $index; track tag) {

                      <nz-tag class="text-wrap mb-2" (nzOnClose)="removeKeyWord(j)"
                        [nzMode]="((salsifyProduct && !copyProduct) || deletedProduct || !isAccessExists()) ? 'default':'closeable'">{{tag}}</nz-tag>
                      }
                    </div>
                    }
                  </div>
                  }
                </ng-container>
              </div>
              <div *ngIf="isEditPage">
                <div class="header d-flex row align-items-center mb-2">
                  <div class="col-md-9 px-4">
                    Lots linked to the Style
                  </div>
                </div>
                <div class="add-catalog-form p-4 row">
                  <ng-container *ngIf="selectedProdctDetails">
                    @if(selectedProdctDetails.lots.length > 0){
                    <div class="lot-keyword-section lots-block mt-2 mb-2 p-3">
                      <div class="d-flex flex-wrap mt-2 w-100">
                        @for(lot of selectedProdctDetails.lots.slice(0, displayLimit); track lot) {
                        <nz-tag class="m-1 text-wrap">{{lot}}</nz-tag>
                        }
                      </div>
                      @if(selectedProdctDetails.lots.length > 10) {
                      <div class="mt-2">
                        <button nz-button nzType="link" (click)="toggleLots()">
                          {{ displayLimit === 10 ? 'Show All' : 'Show Less' }}
                        </button>
                      </div>
                      }
                    </div>
                    } @else {
                    <div class="text-center">
                      <span class="mb-3 fs-12">No lots have been associated yet!</span>
                    </div>
                    }
                  </ng-container>
                </div>
              </div>
            </form>
          </div>

        </ng-container>
        }
      </div>
    </div>
  </div>
</div>
<nz-drawer [nzMaskClosable]="false" [nzKeyboard]="false" [nzWidth]="800" [nzVisible]="attirbutePanel"
  nzTitle="Map Attributes" (nzOnClose)="attirbutePanel = !attirbutePanel">
  <ng-container *nzDrawerContent>
    @if(attirbutePanel && masterCatalogAttirbutes) {
    <app-catalog-attribute-add-edit (emitData)="addAttrData($event)" [salsifyProduct]="salsifyProduct"
      [masterCatalogAttirbutes]="masterCatalogAttirbutes" [productInfo]="attrArray"
      [attributeFormatSwitchValue]="attributeFormatSwitchValue" [openUpdateWindow]="openUpdateWindow"
      [isEditPage]="isEditPage"></app-catalog-attribute-add-edit>
    }
  </ng-container>
</nz-drawer>

<app-confirm-popup *ngIf="showModal" [title]="'Reset Confirmation'" [message]="'Are your sure to revert the changes?'"
  [confirmText]="'Confirm'" [triggerModal]="showModal" [cancelText]="'Cancel'" (confirm)="resetForm()"
  (cancel)="showModal =false"></app-confirm-popup>

<nz-drawer [nzMaskClosable]="false" [nzKeyboard]="false" [nzWidth]="1000" [nzVisible]="productList"
  nzTitle="Linked Products" (nzOnClose)="productList = !productList" [nzExtra]="extraActions">

  <ng-container *nzDrawerContent>
    <app-associated-products #associatedProdComp [selectedProdctId]="selectedProdctId"
      [selectedVersion]="selectedVersion" (emitParentData)="updateToggle($event)">
    </app-associated-products>
  </ng-container>
</nz-drawer>


<ng-template #extraActions>

  <label class="form-label mb-0 px-1">Collapse All</label>
  <nz-switch [(ngModel)]="isAllExpanded" class="toggle"
    (ngModelChange)="associatedProductsComponent.collapseAllProducts($event)"></nz-switch>
</ng-template>